// extracted by mini-css-extract-plugin
export default {"loader":"Loading_loader__OL7hC","animation":"Loading_animation__5ePDH"};